<template>
    <div class="content">
        <div class="content-head-title">新增</div>
        <div class="hw-addcontent">
            <el-descriptions title="" :column="1" border size="medium" labelClassName="custom-label">
                <el-descriptions-item label="客户名称">
                    <span style="margin-right: 10px; font-size: 12px">{{ params.Credit_Control_CustomerName }}</span>
                    <el-button type="primary" size="mini" @click="onOpenCustomer()">查询客户</el-button>
                    <span class="required">*</span>
                </el-descriptions-item>
                <el-descriptions-item label="项目类型">
                    <el-select v-model="params.Credit_Control_Type" placeholder="请选择项目类型" class="el-select-max" value-key="ID" @change="onchangeControlType">
                        <el-option label="请选择项目类型" :value="-1"></el-option>
                        <el-option v-for="item in Control_Typeopt" :key="item.ID" :label="item.Name" :value="item.ID"></el-option>
                    </el-select>
                    <span class="required">*</span>
                </el-descriptions-item>
                <el-descriptions-item label="初始状态">
                    <el-select v-model="params.Credit_Control_State" placeholder="请选择" class="el-select-max" value-key="ID">
                        <template>
                            <el-option v-for="item in Control_Stateopt" :key="item.ID" :label="item.Name" :value="item.ID"></el-option>
                        </template>
                    </el-select>
                    <span class="required">*</span>
                </el-descriptions-item>
                <el-descriptions-item label="经办人">
                    <el-select v-model="params.Credit_Control_Agent" placeholder="请选择经办人" class="el-select-max" filterable clearable value-key="ID">
                        <el-option v-for="item in Control_Agentopt" :key="item.ID" :label="item.ShowName" :value="item.ID"></el-option>
                    </el-select>
                    <span class="required"></span>
                </el-descriptions-item>
                <el-descriptions-item label="包含订单">
                    <el-table :data="creditcontrolorders" border style="max-width: 1000px" :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                        <el-table-column prop="" label="" align="center" width="100">
                            <template slot="header" slot-scope="{}">
                                <el-button type="text" @click="onOpenorders()">查询</el-button>
                            </template>
                            <template slot-scope="scope">
                                <el-button size="mini" type="danger" @click="onDelorders(scope.$index, scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Credit_Control_Orders_SN" label="ERP订单号" align="center" width="180"></el-table-column>
                        <el-table-column prop="Credit_Control_Orders_EngineeringName" label="工程名称" show-overflow-tooltip align="center"></el-table-column>
                        <el-table-column prop="Credit_Control_Orders_MemberName" label="合同签订人" align="center" width="180"></el-table-column>
                        <el-table-column prop="Credit_Control_Orders_RegionCode" label="分支机构" align="center" width="180"></el-table-column>
                    </el-table>
                </el-descriptions-item>
                <el-descriptions-item label="项目金额">
                    <el-input v-model="params.Credit_Control_ProjectMoney" clearable class="el-select-max" @input="handleInput($event, 'params', 'Credit_Control_ProjectMoney')"></el-input>
                    <span class="required">*</span>
                </el-descriptions-item>
                <el-descriptions-item label="承诺还款" v-if="params.Credit_Control_Type != 3 && params.Credit_Control_Type != 4 && params.Credit_Control_Type != 5 && params.Credit_Control_Type != 6 && params.Credit_Control_Type != 7">
                    <el-table :data="creditcontrolrepayments" border style="max-width: 1000px" :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                        <el-table-column prop="" label="" align="center">
                            <template slot="header" slot-scope="{}">
                                <el-button type="text" @click="getOpenTransfermoney()">新增</el-button>
                            </template>
                            <template slot-scope="scope">
                                <el-button size="mini" type="danger" @click="onDelpayments(scope.$index, scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Credit_Control_Repayment_Time" label="还款日期" align="center"></el-table-column>
                        <el-table-column prop="Credit_Control_Repayment_ReturnMoney" label="还款金额" align="center"></el-table-column>
                    </el-table>
                    <span class="required" style="font-size: 12px; line-height: 50px">口头还款计划,书面还款计划至少包含一条承诺还款信息</span>
                </el-descriptions-item>
                <el-descriptions-item label="发函日期" v-if="params.Credit_Control_Type == 4 || params.Credit_Control_Type == 5 || params.Credit_Control_Type == 6">
                    <el-date-picker v-model="params.LetterTime" class="el-select-max" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" clearable></el-date-picker>
                </el-descriptions-item>
                <el-descriptions-item label="快递公司" v-if="params.Credit_Control_Type == 4 || params.Credit_Control_Type == 5 || params.Credit_Control_Type == 6">
                    <el-select v-model="params.Credit_Control_DeliveryName" placeholder="请选择" class="el-select-max" clearable>
                        <el-option v-for="item in Control_DeliveryNameopt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-descriptions-item>
                <el-descriptions-item label="快递单号" v-if="params.Credit_Control_Type == 4 || params.Credit_Control_Type == 5 || params.Credit_Control_Type == 6">
                    <el-input v-model="params.Credit_Control_DeliveryCode" clearable class="el-select-max"></el-input>
                </el-descriptions-item>
                <el-descriptions-item label="项目成立日期">
                    <el-date-picker v-model="params.ApplicationTime" class="el-select-max" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" clearable></el-date-picker>
                </el-descriptions-item>
                <el-descriptions-item label="附件">
                    <div style="width: 300px">
                        <el-upload class="upload-demo" ref="upload" :action="$fileUpLoadUrl" :on-preview="handlePreview" :on-change="handleUploadChange" :on-remove="handleRemove" :file-list="fileList" :auto-upload="false">
                            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                            <el-button style="margin-left: 10px" size="small" type="success" @click="submitUpload" v-if="fileList && fileList.length > 0">上传</el-button>
                        </el-upload>
                    </div>
                </el-descriptions-item>
                <el-descriptions-item label="附件名称">
                    <el-input v-model="params.AttachmentName" :disabled="!params.Credit_Remarks" placeholder="请输入附件名称" clearable class="el-select-max"></el-input>
                    <span class="required" style="font-size: 12px">不上传附件可不维护附件名称</span>
                </el-descriptions-item>
            </el-descriptions>
        </div>
        <div class="hw-addcontent-footer">
            <el-button @click="onCloseTabs()">取 消</el-button>
            <el-button type="primary" @click="onSubmit()">保存</el-button>
        </div>

        <el-dialog title="查找客户" :visible.sync="isShowdialog" width="600px" :before-close="onCloseCustomer" :close-on-click-modal="false">
            <div class="client">
                <div class="client-head">
                    <el-input v-model="Customer_Name" clearable class="el-select-big" placeholder="请数据客户名称全称检索"></el-input>
                    <el-button type="primary" icon="el-icon-search" style="margin-left: 10px" @click="getSelectCreditCustomer()" :loading="isLoading">检索</el-button>
                </div>
                <el-table :data="Customer_list" border :header-cell-style="{ backgroundColor: '#F5F7FA' }" :loading="isLoading">
                    <el-table-column label="客户名称" align="center">
                        <template slot-scope="scope">
                            <el-radio @input="onInputCustomerId($event, scope.row)" v-model="selectedRowId" :label="scope.row.Credit_Customer_ID">{{ scope.row.Credit_Customer_Name }}</el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Credit_Customer_UniformCode" label="客户编号" align="center"></el-table-column>
                </el-table>
            </div>

            <span slot="footer" class="dialog-footer" style="display: flex; justify-content: center" v-if="selectedRowId">
                <el-button @click="onCloseCustomer">取消</el-button>
                <el-button type="primary" @click="onSaveCustomerId()">保存</el-button>
            </span>
            <div v-else style="height: 62px"></div>
        </el-dialog>

        <el-dialog title="查找订单" :visible.sync="isShowOrder" width="600px" :before-close="onCloseERPOrders" :close-on-click-modal="false">
            <div class="client">
                <div class="client-head">
                    <el-input v-model="Orders_ERPSN" clearable class="el-select-big" placeholder="ERP订单编号(多个订单号请用英文半角,分割)"></el-input>
                    <el-button type="primary" icon="el-icon-search" style="margin-left: 10px" @click="getCreditERPOrders()" :loading="isLoading">检索</el-button>
                </div>
                <el-table :data="Control_Ordersopt" border :header-cell-style="{ backgroundColor: '#F5F7FA' }" :loading="isLoading">
                    <el-table-column prop="Credit_Control_Orders_SN" label="ERP订单号" align="center" width="120"></el-table-column>
                    <el-table-column prop="Credit_Control_Orders_EngineeringName" label="工程名称" show-overflow-tooltip align="center"></el-table-column>
                    <el-table-column prop="Credit_Control_Orders_MemberName" label="合同签订人" align="center" width="150"></el-table-column>
                    <el-table-column prop="Credit_Control_Orders_RegionCode" label="分支机构" align="center" width="150"></el-table-column>
                </el-table>
            </div>

            <span slot="footer" class="dialog-footer" style="display: flex; justify-content: center" v-if="Control_Ordersopt && Control_Ordersopt.length > 0">
                <el-button @click="onCloseERPOrders()">取消</el-button>
                <el-button type="primary" @click="onSaveERPOrders()">保存</el-button>
            </span>
            <div v-else style="height: 62px"></div>
        </el-dialog>

        <el-dialog title="新增承诺还款" :visible.sync="isTransfermoney" :before-close="onCloserepayment" center width="320px" :close-on-click-modal="false">
            <div class="transfermoney">
                <div class="transfermoney-block">
                    <el-date-picker v-model="repayment.Credit_Control_Repayment_Time" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" clearable></el-date-picker>
                </div>
                <div class="transfermoney-block">
                    <el-input v-model="repayment.Credit_Control_Repayment_ReturnMoney" placeholder="请输入还款金额" @input="handleInput($event, 'repayment', 'Credit_Control_Repayment_ReturnMoney')" clearable></el-input>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="onCloserepayment()">取消</el-button>
                <el-button type="primary" @click="onSaverepayment()">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { cloneDeep, debounce } from 'lodash';
import { toLowerCaseKeys } from '@/utils/utils.js';
export default {
    name: 'controlprojectAdd',
    props: {
        isControlAdd: {
            type: Boolean,
            default: () => false
        }
    },
    data() {
        return {
            isTransfermoney1: true,
            keyword: '',
            isTransfermoney: false,
            isShowdialog: false,
            isShowOrder: false,
            Customer_Name: '',
            Credit_Control_CustomerName: '',
            Orders_ERPSN: '',
            isLoading: false,
            selectedRowId: null,
            repayment: {
                Credit_Control_Repayment_Time: '',
                Credit_Control_Repayment_ReturnMoney: ''
            },
            params: {
                Credit_Control_CustomerID: '',
                Credit_Control_CustomerName: '',
                Credit_Control_Type: -1,
                Credit_Control_State: '',
                Credit_Control_Agent: '',
                Select_OfficeMember: '',
                Credit_Control_ProjectMoney: '',
                LetterTime: '',
                Credit_Control_DeliveryName: '',
                Credit_Control_DeliveryCode: '',
                ApplicationTime: '',
                Credit_Remarks: '',
                AttachmentName: '',
                action: 'new'
            },
            creditcontrolorders: [],
            creditcontrolrepayments: [],
            Control_Typeopt: [],
            Control_Stateopt: [],
            Control_Agentopt: [],
            Control_DeliveryNameopt: [], //快递公司
            Control_Ordersopt: [],
            fileList: [],
            Customer_list: []
        };
    },
    mounted() {
        const result = sessionStorage.getItem('controlprojectList');
        this.Control_Typeopt = JSON.parse(result);
        this.getOfficeMemberSelectOption();
        this.getDelivery_Company_Select();
    },
    methods: {
        onSubmit: debounce(function () {
            let params = cloneDeep(this.params);
            if (!params.Credit_Control_State) {
                params.Credit_Control_State = 0;
            }
            if (!params.Credit_Control_Agent) {
                params.Credit_Control_Agent = 0;
            }
            console.log(params, this.creditcontrolorders, this.creditcontrolrepayments);
            const result = { json: JSON.stringify(toLowerCaseKeys(params)), creditcontrolorders: this.creditcontrolorders, creditcontrolrepayments: this.creditcontrolrepayments };
            this.$newsApi.getAddCredit(result).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                    setTimeout(() => {
                        this.$store.dispatch('delView', this.$route);
                        this.$router.push('/creditControlproject/index?t=' + Date.now()); // 替换当前路由
                    }, 2000);
                }
            });
        }, 800),
        onCloseTabs() {
            // 调用全局挂载的方法-在需要关闭当前路由的页面
            console.log(this.$route, this.$store, 'this.$route');
            this.$store.dispatch('delView', this.$route);
            this.$router.push('/creditControlproject/index?t=' + Date.now()); // 替换当前路由
        },
        /*
    查询客户
    */
        getSelectCreditCustomer() {
            this.isLoading = true;
            this.$newsApi
                .getSelectCreditCustomer({ Customer_Name: this.Customer_Name })
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.Customer_list = res.data.data;
                    }
                })
                .finally(() => (this.isLoading = false));
        },
        onOpenCustomer() {
            this.Customer_Name = '';
            this.selectedRowId = null;
            this.isShowdialog = true;
            this.Customer_list = [];
        },
        onSaveCustomerId() {
            if (this.selectedRowId) {
                this.params.Credit_Control_CustomerID = this.selectedRowId;
                this.params.Credit_Control_CustomerName = this.Credit_Control_CustomerName;
                this.isShowdialog = false;
            }
        },
        onCloseCustomer() {
            this.isShowdialog = false;
        },
        onInputCustomerId(e, row) {
            this.selectedRowId = row.Credit_Customer_ID;
            this.Credit_Control_CustomerName = row.Credit_Customer_Name;
        },
        onchangeControlType(e) {
            console.log(e, 'eee');
            this.Control_Stateopt = [];
            this.params.Credit_Control_State = '';
            this.getCreditState();
        },
        getCreditState() {
            this.$newsApi.getCreditState({ type: this.params.Credit_Control_Type }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.Control_Stateopt = res.data.data;
                }
            });
        },
        //新增操作还款
        getOpenTransfermoney() {
            this.isTransfermoney = true;
            this.repayment = {
                Credit_Control_Repayment_ReturnMoney: '',
                Credit_Control_Repayment_Time: ''
            };
        },
        onSaverepayment() {
            if (this.repayment.Credit_Control_Repayment_Time == '') {
                this.$message({
                    message: '请输入还款日期！',
                    type: 'warning'
                });
                return;
            }
            if (this.repayment.Credit_Control_Repayment_ReturnMoney == '') {
                this.$message({
                    message: '请输入还款金额！',
                    type: 'warning'
                });
                return;
            }
            this.creditcontrolrepayments.push({
                ...this.repayment,
                Credit_Control_Repayment_InCompleteMoney: this.repayment.Credit_Control_Repayment_ReturnMoney,
                Credit_Control_Repayment_OverdueReturnMoney: 0,
                Credit_Control_Repayment_AgentRemind: 0,
                Credit_Control_Repayment_CreditID: 0,
                Credit_Control_Repayment_ID: 0
            });
            this.isTransfermoney = false;
        },
        onDelpayments(index, row) {
            this.creditcontrolrepayments.splice(index, 1);
        },
        onCloserepayment() {
            this.isTransfermoney = false;
        },
        /*
    ERP订单查询
    */
        getCreditERPOrders() {
            this.isLoading = true;
            let params = toLowerCaseKeys({ Orders_ERPSN: this.Orders_ERPSN });
            this.$newsApi
                .getCreditERPOrders(params)
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.Control_Ordersopt = res.data.data;
                    }
                })
                .finally(() => (this.isLoading = false));
        },
        onOpenorders() {
            this.isShowOrder = true;
            this.Orders_ERPSN = '';
            this.Control_Ordersopt = [];
        },
        onDelorders(index, row) {
            this.creditcontrolorders.splice(index, 1);
        },
        onSaveERPOrders() {
            this.creditcontrolorders = [...this.creditcontrolorders, ...this.Control_Ordersopt];
            this.isShowOrder = false;
        },
        onCloseERPOrders() {
            this.isShowOrder = false;
        },
        /*
    查询经办人
    */
        getOfficeMemberSelectOption() {
            // { select_officemember: this.select_officemember }
            this.$newsApi.getOfficeMemberSelectOption().then((res) => {
                if (res.data.Resultcode == 0) {
                    this.Control_Agentopt = res.data.data;
                }
            });
        },

        /*
    查询快递公司
    */
        getDelivery_Company_Select() {
            this.$newsApi.getDelivery_Company_Select().then((res) => {
                if (res.data.Resultcode == 0) {
                    const optionsObj = res.data.data;
                    // 转换为 Element UI 下拉框格式的数组
                    this.Control_DeliveryNameopt = Object.entries(optionsObj).map(([key, value]) => {
                        return {
                            value: key,
                            label: value
                        };
                    });
                }
            });
        },

        /*
    文件上传
    */
        handleUploadChange(file) {
            this.fileList = [{ ...file }];
            console.log(this.fileList);
        },
        submitUpload() {
            console.log(this.fileList, '========');
            //   this.$refs.upload.submit()
            this.getFileUpLoad();
        },
        handleRemove(file, fileList) {
            this.fileList = [];
            this.params.Credit_Remarks = '';
        },
        handlePreview(file) {
            console.log(file);
        },
        async getFileUpLoad() {
            // 创建 FormData 对象
            const formData = new FormData();
            formData.append('file', this.fileList[0].raw); // 通过append向form对象添加数据
            formData.append('path', 'credit');
            try {
                // 发送 POST 请求
                const response = await this.$axios.post(this.$fileUpLoadUrl, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                if (response.data.Resultcode == 0) {
                    this.params.Credit_Remarks = response.data.data;
                    this.$message({
                        showClose: true,
                        message: '上传成功',
                        type: 'success'
                    });
                } else {
                    this.$message({
                        showClose: true,
                        message: response.data.Resultinfo || '上传失败',
                        type: 'warning'
                    });
                }
            } catch (error) {
                console.error('文件上传失败:', error);
            }
        },
        handleInput(value, obj, key) {
            console.log(value, key);
            // 只允许输入数字和小数点，并且小数点不能作为第一位
            const cleanedValue = value.replace(/[^\d.]/g, ''); // 移除非数字和小数点的字符
            const regex = /^\d*\.?\d*$/;
            if (regex.test(cleanedValue)) {
                if (cleanedValue.startsWith('.')) {
                    // 小数点不能是第一位，自动添加0在前面
                    this[obj][key] = '0' + cleanedValue;
                } else {
                    this[obj][key] = cleanedValue;
                }
            }
        }
    }
};
</script>

<style lang="scss" scoped>
/deep/ .custom-label {
    text-align: right !important;
    width: 180px !important;
    color: #333333;
    background: #f5f7fa !important;
}

.content {
    padding: 0px 20px 20px 20px;
    background: #fff;
    height: calc(100vh - 104px);
    overflow: auto;
}
.content-head-title {
    height: 50px;
    line-height: 50px;
}

.required {
    color: red;
    margin-left: 4px;
}
.hw-addcontent-footer {
    margin-top: 20px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.client {
    margin-bottom: 20px;
    .client-head {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
    }
}
.transfermoney {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
}
.transfermoney-block {
    width: 220px;
    margin-bottom: 20px;
}
.transfermoney-block:last-child {
    margin-bottom: 0px;
}
.hw-form-item {
    padding: 10px 0px;
    display: flex;
    align-items: center;
}
.hw-form-item-label {
    text-align: right;
    width: 150px;
}
</style>
